module.exports = __webpack_public_path__ + "static/media/flags-for-phone-input.adff9a6c.png";